<template>
  <div class="number-grow-wrap">
    <span ref="numberGrow" :data-value="value" class="number-grow">0</span>
  </div>
</template>
  
  <script>
export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    numberGrow(ele) {
      let _this = this;

      let step = (_this.value * 20) / 3000; // 计算每毫秒递增的步数
      let current = 0;
      let start = 0;
      let t = setInterval(function () {
        start += step;
        if (start > _this.value) {
          clearInterval(t);
          start = _this.value;
          t = null;
        }
        if (current === start) {
          return;
        }
        current = start;
        ele.innerHTML = current
          .toFixed(0)
          .toString()
          .replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
      }, 1);
    },
  },
  mounted() {
    const maxDigits = 99999; // 数字的最高位数不超过五位

    if (this.value > maxDigits) {
      this.value = maxDigits;
    }

    this.numberGrow(this.$refs.numberGrow);
  },
};
</script>
  
  <style>
.number-grow-wrap {
  transform: translateZ(0);
}
</style>


// WEBPACK FOOTER //
// src/components/numScoll.vue